// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__mHwhU","filesListContainer":"PosDisputesFiles_filesListContainer__1PsYZ","filesButton":"PosDisputesFiles_filesButton__3J5Q1"};